import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/storage';

if (process.env.REACT_APP_PROD === 'true') {
  console.log('prod dogo');
  firebase.initializeApp({
    apiKey: "AIzaSyDQ11Dwow45vF243_RHe0cqUfCnfW92ZT0",
    authDomain: "dogo-8da73.firebaseapp.com",
    databaseURL: "https://dogo-8da73.firebaseio.com",
    projectId: "dogo-8da73",
    storageBucket: "dogo-8da73.appspot.com",
    messagingSenderId: "710795219136",
    appId: "1:710795219136:web:ed8a5bb5583914b09f1d25",
    measurementId: "G-J9PTSWGX58"
  });
}
else {
  console.log('dev dogo ');
  firebase.initializeApp({
    apiKey: "AIzaSyBTEarWfrXUcrPvl_l3Y8hd5mMa5vGBfUg",
    authDomain: "dogo-develop.firebaseapp.com",
    databaseURL: "https://dogo-develop.firebaseio.com",
    projectId: "dogo-develop",
    storageBucket: "dogo-develop.appspot.com",
    messagingSenderId: "892350186879",
    appId: "1:892350186879:web:3aff0717044ec0f571864a",
    measurementId: "G-L6HTG743YB"
  });
}

export default firebase;
